import axios from 'axios';
import {LanguageService} from "./LanguageService";
import {user} from "../utils/Utils";
import {resetTidio} from "../utils/Tidio";
import {DateTime} from "luxon";
import {withMaintenanceDetection} from "../utils/maintenance";

export class AuthService {
    // Production URLs are the baked-in defaults (no env needed in prod).
    // For local dev, set REACT_APP_API_URL (e.g. http://localhost:8000/) in
    // .env.local to point all API calls at your local backend.
    static reportBaseURLs = ['dashboards/', 'product_export/', 'product_import_excel/', 'product_upload/', 'product_import_excel/']
    static baseURL = process.env.REACT_APP_API_URL || `https://api.pricerest.com/`;
    static coreApiURL = process.env.REACT_APP_API_URL || `https://apido01.pricerest.com/`;
    static reportApiURL = process.env.REACT_APP_API_URL || `https://apido01.pricerest.com/`;

    static getAxios = (url) => {
        let baseURL = AuthService.coreApiURL;
        let timeout = 40000;
        if (AuthService.reportBaseURLs.some(baseURL => url.includes(baseURL))) {
            baseURL = AuthService.reportApiURL
            timeout = 100000;
        }
        return withMaintenanceDetection(axios.create({
            baseURL: baseURL,
            timeout: timeout,
            headers: {'Authorization': 'Token ' + localStorage.getItem("id_token")},
            validateStatus: function (status) {
                return status >= 200 && status <= 226 ;
            }
        }));
    };

    static logout = () => {
        window.location = '#/login';

        resetTidio();
        localStorage.removeItem("id_token");
        localStorage.removeItem("user");
        localStorage.removeItem("loggedInEmail");
        localStorage.removeItem("token_created_time");
        localStorage.removeItem("subscription");
        localStorage.removeItem("next_subscription");
        localStorage.removeItem("loginRetry");
        localStorage.removeItem("i18nextLng");
        localStorage.removeItem("language");
        // "two_factor_device_token" is deliberately NOT removed here: forgetting
        // it on every sign-out would ask for a two-factor code on every single
        // sign-in and make the "remember this device" option meaningless. Nothing
        // in this app ever removes the local token; "forget all devices" in
        // Account only calls the API, which deletes the matching rows server
        // side (as does the server's own 30-day expiry), so the stale local
        // token simply stops matching anything from then on.
    };



    static apiGet(url, config)
    {
        return AuthService.getAxios(url).get(url, config).catch((error) => {throw error});
    }
    static apiPut(url, data, config)
    {
        return AuthService.getAxios(url).put(url, data, config).catch((error) => {throw error});
    }
    static apiPost(url, data, config)
    {
        return AuthService.getAxios(url).post(url, data, config).catch((error) => {throw error});
    }
    static apiDelete(url, config)
    {
        return AuthService.getAxios(url).delete(url, config).catch((error) => {throw error});
    }

    static setToken = idToken => {
        localStorage.setItem("id_token", idToken);
    };

    static getToken = () => {
        return localStorage.getItem("id_token");
    };

    // The trusted-device token deliberately outlives a sign-out: forgetting it
    // on logout would ask for a code on every single sign-in and make the
    // "remember this device" option meaningless. Nothing in this app ever
    // removes the local token; "forget all devices" in Account only calls the
    // API, which deletes the matching rows server side (as does the server's
    // own 30-day expiry), so the stale local token simply stops matching
    // anything from then on.
    static getDeviceToken = () => {
        return localStorage.getItem("two_factor_device_token");
    };

    static setDeviceToken = (token) => {
        if (token)
            localStorage.setItem("two_factor_device_token", token);
    };

    static setUser (user) {
        localStorage.setItem("user", JSON.stringify(user));
    };

    static changeIsAdmin () {
        let u = user();
        u.is_admin = false;
        AuthService.setUser(u);
    };

    static setLoggedInEmail (email) {
        localStorage.setItem("loggedInEmail", email);
    };

    static setSubscription (subscription) {
        localStorage.setItem("subscription", JSON.stringify(subscription));
    };
    static setNextSubscription (next_subscription) {
        localStorage.setItem("next_subscription", JSON.stringify(next_subscription));
    };
    static setTokenCreatedTime = createdTime => {
        localStorage.setItem("token_created_time", createdTime.toMillis());
    };

    static getTokenCreatedTime = () => {
        return localStorage.getItem("token_created_time");
    };

    static loggedIn = () => {
        if (AuthService.getTokenCreatedTime())
        {
            const token = AuthService.getToken();
            let now = DateTime.now();
            let end = DateTime.fromMillis(+AuthService.getTokenCreatedTime());
            if (!end.isValid)
                return false;
            end = end.startOf('day').plus({days:1, hours: 3})
            return !!token && now < end;
        }
        return false;
    };

    static setUserAndToken(res) {
        AuthService.setToken(res.data.token);
        AuthService.setTokenCreatedTime(DateTime.now());
        AuthService.setLoggedInEmail(res.data.logged_in_email);
        AuthService.setUser(res.data.user);
        AuthService.setSubscription(res.data.subscription);
        AuthService.setNextSubscription(res.data.next_subscription);

        LanguageService.setLanguage(res.data.user.language);

    }
}
